import { WidgetConfig } from '@wix/da-gruser-shared/pkg/types/widget';
import defaultRemoveConfirmation from '@wix/da-shared-react/pkg/widgets/defaultRemoveConfirmation';
import MyCommentsBoxWide from './MyCommentsBoxWide';
import initActionsCreator from './redux/initModule';

export const getMyCommentsWidgetConfig = ({ t, dispatch }): WidgetConfig => ({
  viewComponent: MyCommentsBoxWide,
  confirmRemove: () => defaultRemoveConfirmation({ t, dispatch }),
  widgetCard: {
    minuatureImageSrc:
      'https://st.deviantart.net/eclipse/widgets/miniatures/2022/il8-14-comments.svg',
    title: t('widgets.myComments.addButtonHeader'),
    description: t('widgets.myComments.description'),
  },
  initActionsCreator,
});
